<template>
  <div class="m-24">
    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div
            class="shadow overflow-hidden border-b border-gray-200
                sm:rounded-lg border"
          >
            <table class="min-w-full divide-y divide-gray-200">
              <thead>
                <tr>
                  <th
                    class="px-6 py-3 bg-gray-50 text-left text-xs leading-4
                        font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Name
                  </th>
                  <th
                    class="px-6 py-3 bg-gray-50 text-left text-xs leading-4
                        font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Title
                  </th>
                  <th
                    class="px-6 py-3 bg-gray-50 text-left text-xs leading-4
                        font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Email
                  </th>
                  <th
                    class="px-6 py-3 bg-gray-50 text-left text-xs leading-4
                        font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Role
                  </th>
                  <th class="px-6 py-3 bg-gray-50" />
                </tr>
              </thead>
              <tbody>
                <!-- Odd row -->
                <tr
                  v-for="item in results"
                  :key="item.id"
                  class="bg-white"
                >
                  <td
                    class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium
                        text-gray-900"
                  >
                    {{ item.id }}
                  </td>
                  <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">
                    Regional Paradigm Technician
                  </td>
                  <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">
                    jane.cooper@example.com
                  </td>
                  <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">
                    Admin
                  </td>
                </tr>

                <!-- Even row
                    <tr class="bg-gray-50">
                        <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium
                        text-gray-900">
                        Cody Fisher
                        </td>
                        <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">
                        Product Directives Officer
                        </td>
                        <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">
                        cody.fisher@example.com
                        </td>
                        <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">
                        Owner
                        </td>
                        <td class="px-6 py-4 whitespace-no-wrap text-right text-sm leading-5
                        font-medium">
                        <a href="#" class="text-indigo-600 hover:text-indigo-900">Edit</a>
                        </td>
                    </tr> -->

                <!-- More rows... -->
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetPaginatedList } from '@/app/shared/services/paginatedListService/paginatedListService';
import { AppInfoService } from '@/app/shared/services/appInfoService/appInfoService';

export default {
  name: 'PaginatedTable',

  components: {

  },

  props: {
    type: {
      type: String,
      default: undefined,
    },
  },

  data() {
    return {
      results: undefined,
      serviceInfo: undefined,
      loading: true,
    };
  },

  mounted() {
    this.getServiceInfo();
    this.getList();
  },

  methods: {
    getServiceInfo() {
      AppInfoService(this.type).then((data) => {
        this.serviceInfo = data;
      });
    },
    getList() {
      this.loading = true;
      GetPaginatedList(`${this.type}/GetAll`, null, 0, 10).then((data) => {
        this.results = data;
        this.loading = false;
      });
    },
  },

};
</script>
